export default function MangakuContact() {
  return (
    <section id="contact" className="py-24 bg-gray-900">
      <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center">
        <span className="text-xs tracking-[0.3em] text-red-400/70 font-medium uppercase mb-4 block">Contact</span>
        <h2 className="text-4xl md:text-5xl font-serif text-white mb-4">買取・販売のご相談</h2>
        <div className="w-16 h-0.5 bg-red-400/30 mx-auto mb-6"></div>
        <p className="text-white/60 text-sm max-w-lg mx-auto leading-relaxed mb-12">
          ポケモンカード・ワンピースカードなどの買取・販売は<br />
          LINEまたは店頭にてお気軽にご相談ください。
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-2xl mx-auto mb-10">
          <a
            href="https://lin.ee/OGQq9z6"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#06C755] rounded-2xl p-7 flex flex-col items-center gap-4 hover:bg-[#05b34c] transition-colors cursor-pointer group"
          >
            <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-full group-hover:bg-white/30 transition-colors">
              <i className="ri-line-fill text-white text-2xl"></i>
            </div>
            <div>
              <p className="text-white font-semibold text-base mb-1">LINEで相談</p>
              <p className="text-white/70 text-xs">公式LINEよりお問い合わせ</p>
            </div>
            <span className="text-xs text-white/60 bg-white/10 px-3 py-1 rounded-full">おすすめ・最速対応</span>
          </a>

          <a
            href="https://www.google.com/maps?q=香川県高松市瓦町2-1-28"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white/10 rounded-2xl p-7 flex flex-col items-center gap-4 hover:bg-white/15 transition-colors cursor-pointer group"
          >
            <div className="w-14 h-14 flex items-center justify-center bg-white/10 rounded-full group-hover:bg-white/20 transition-colors">
              <i className="ri-store-line text-white text-2xl"></i>
            </div>
            <div>
              <p className="text-white font-semibold text-base mb-1">店頭へ来店</p>
              <p className="text-red-300 text-sm font-medium">高松市瓦町2-1-28</p>
              <p className="text-white/50 text-xs mt-0.5">高尾ビル2F南</p>
            </div>
            <span className="text-xs text-white/60 bg-white/10 px-3 py-1 rounded-full">予約不要・当日OK</span>
          </a>
        </div>

        <div className="bg-white/5 rounded-xl px-6 py-4 inline-flex items-center gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <i className="ri-time-line text-red-400 text-sm"></i>
          </div>
          <p className="text-white/50 text-xs">営業時間：10:00〜19:00（平日・土日祝）</p>
        </div>
      </div>
    </section>
  );
}
